<template>
  <CSidebar
    position="fixed"
    selfHiding="md"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <a class="header-logo" href="/">
      <img class="header-logo__img" :src="logo" />SoundType AI
    </a>
    <div
      style="
        width: 100%;
        padding-left: var(--st-sidebar-padding);
        padding-right: var(--st-sidebar-padding);
        margin-top: 12px;
        margin-bottom: 32px;
      "
    >
      <TranscribeButton :is-full-width="true" />
    </div>
    <AppSidebarNav />
    <ul class="sidebar-nav" style="flex: none">
      <!--      <li class="nav-item">-->
      <!--        <a class="nav-link">-->
      <!--          <div style="width: 100%">-->
      <!--            <div style="display: flex">-->
      <!--              <div style="font-weight: bold; font-size: 14px">-->
      <!--                {{ getPlanName() }}-->
      <!--              </div>-->
      <!--              &lt;!&ndash;              <div&ndash;&gt;-->
      <!--              &lt;!&ndash;                style="&ndash;&gt;-->
      <!--              &lt;!&ndash;                  font-weight: bold;&ndash;&gt;-->
      <!--              &lt;!&ndash;                  font-size: 12px;&ndash;&gt;-->
      <!--              &lt;!&ndash;                  color: black;&ndash;&gt;-->
      <!--              &lt;!&ndash;                  margin-left: auto;&ndash;&gt;-->
      <!--              &lt;!&ndash;                "&ndash;&gt;-->
      <!--              &lt;!&ndash;              >&ndash;&gt;-->
      <!--              &lt;!&ndash;                Used {{ usedMinutes / 60 }}/{{ maxMinutes / 60 }} minutes&ndash;&gt;-->
      <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            </div>-->
      <!--            &lt;!&ndash;            <CProgress&ndash;&gt;-->
      <!--            &lt;!&ndash;              color="info"&ndash;&gt;-->
      <!--            &lt;!&ndash;              :value="(remainingMinutes / maxMinutes) * 100"&ndash;&gt;-->
      <!--            &lt;!&ndash;              style="height: 12px; border-radius: 24px; margin: 4px 0"&ndash;&gt;-->
      <!--            &lt;!&ndash;            />&ndash;&gt;-->
      <!--            <div style="font-weight: bold; font-size: 11px; color: grey">-->
      <!--              <div>-->
      <!--                {{-->
      <!--                  $t('remaining_x_minutes', {-->
      <!--                    x: formatNumber(remainingMinutes / 60),-->
      <!--                  })-->
      <!--                }}-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </a>-->
      <!--      </li>-->
      <li class="nav-item">
        <a class="nav-link">
          <AccountCircleIcon style="display: none" />
          <div style="width: 100%">
            <div>{{ getPlanName() }}</div>
            <CProgress
              color="info"
              :value="(usedMinutes / maxMinutes) * 100"
              style="height: 4px; border-radius: 24px; margin: 4px 0"
            />
            <div style="font-size: 12px; color: grey">
              <!--              {{-->
              <!--                $t('x_minutes_left', { x: formatNumber(remainingMinutes / 60) })-->
              <!--              }}-->
              {{
                $t('x_y_minutes_used', {
                  x: formatNumber(usedMinutes / 60),
                  y: formatNumber(maxMinutes / 60),
                })
              }}
            </div>
          </div>
        </a>
      </li>
    </ul>
    <div style="height: 20px" />
    <!--    <div-->
    <!--      style="-->
    <!--        color: black;-->
    <!--        font-size: 12px;-->
    <!--        text-align: center;-->
    <!--        margin-bottom: 8px;-->
    <!--      "-->
    <!--    >-->
    <!--      v{{ version }}-->
    <!--    </div>-->
    <PurchaseModal
      :visible="isShowPurchaseDialog"
      @close="() => (isShowPurchaseDialog = false)"
    />
    <!--    <CSidebarToggler-->
    <!--      class="d-none d-lg-flex"-->
    <!--      @click="$store.commit('toggleUnfoldable')"-->
    <!--    />-->
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import TranscribeButton from '@/components/TranscribeButton.vue'
import AccountCircleIcon from 'vue-material-design-icons/AccountCircle.vue'
import PurchaseModal from '@/components/purchases/PurchaseModal.vue'
import { AuthHelper } from '@/api_client'
import logo from '../assets/logo_blue_small.png'
import Auth from '@/components/auth/Auth.vue'

export default {
  name: 'AppSidebar',
  components: {
    TranscribeButton,
    AppSidebarNav,
    AccountCircleIcon,
    PurchaseModal,
  },
  data() {
    return {
      version: '1.8.3',
      logo,
      isShowPurchaseDialog: false,
      isShowUploadDialog: false,
      userEmail: AuthHelper.getEmail(),
      subscriptionUid: AuthHelper.getSubscriptionUid(),
      isPurchased: AuthHelper.isPaidUser(),
      prodMode: process.env.NODE_ENV === 'production',
      remainingMinutes: AuthHelper.getCredits(),
      maxMinutes: AuthHelper.getMaxCredits(),
      usedMinutes: AuthHelper.getUsedCredits(),
    }
  },
  created() {
    this.refreshUser()
  },
  methods: {
    formatNumber(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 0,
      }).format(value)
    },
    getPlanName() {
      var planUid = this.subscriptionUid
      if (planUid?.includes('pro')) {
        return this.$t('pro_plan')
      } else if (planUid?.includes('business')) {
        return this.$t('business_plan')
      } else {
        return this.$t('basic_plan')
      }
    },
    async refreshUser() {
      try {
        const user = await this.apiClient.getUser()
        AuthHelper.userLogin(user)
        this.$i18n.locale = user.display_language
        this.subscriptionUid = AuthHelper.getSubscriptionUid()
        this.remainingMinutes = user.credits
      } catch (e) {
        console.log(e)
      }
    },
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const store = useStore()

    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
}
</script>
<style lang="scss" scoped>
.sc-logo {
  color: #6be69b;
  padding: 2px 12px 0 12px;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -1px;
  text-transform: uppercase;
}

.nav-link {
  span {
    margin-right: 20px;
  }
}

.nav-link:hover {
  cursor: pointer;
}

.header-logo {
  line-height: 24px;
  font-size: 18px;
  padding-left: var(--st-sidebar-padding);
  padding-right: var(--st-sidebar-padding);
  padding-top: var(--st-sidebar-padding);
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;
  color: black;
  margin-bottom: 20px;

  &__img {
    width: 36px;
    margin-right: 8px;
  }
}
</style>
